import React, { memo, ReactElement, Children, cloneElement } from 'react'

export interface ITableFootProps {
  id?: string
  children: ReactElement
  dataTest?: string
}

export const TableFoot = memo<ITableFootProps>(({ children, dataTest }) => (
  <tfoot data-test={dataTest}>
    {Children.map(children, (child: ReactElement) => cloneElement(child, { tableCellType: 'td' }))}
  </tfoot>
))
